import { CURRENCY_SYMBOL } from '../../utils/currency';
import React from 'react';
import { Users, UserCheck, Clock, DollarSign } from 'lucide-react';
import type { MemberStatsData } from '../../types/memberships';

interface MemberStatsProps {
  stats: MemberStatsData;
}

export function MemberStats({ stats }: MemberStatsProps) {
  const cards = [
    {
      label: 'Active Members',
      value: stats.active_members.toString(),
      icon: UserCheck,
      bgColor: 'bg-blue-500',
    },
    {
      label: 'Total Members',
      value: stats.total_members.toString(),
      icon: Users,
      bgColor: 'bg-green-500',
    },
    {
      label: 'Expiring Soon',
      value: stats.expiring_soon.toString(),
      icon: Clock,
      bgColor: 'bg-orange-500',
    },
    {
      label: 'Venue Earnings',
      value: `${CURRENCY_SYMBOL}${Number(stats.venue_earnings).toLocaleString()}`,
      icon: DollarSign,
      bgColor: 'bg-purple-500',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {cards.map((card, idx) => (
        <div
          key={idx}
          className={`${card.bgColor} rounded-lg p-3 sm:p-4 text-white relative overflow-hidden`}
        >
          <div className="relative z-10">
            <div className="flex items-center justify-between mb-1.5 sm:mb-2">
              <p className="text-white text-xs font-semibold opacity-90 truncate">
                {card.label}
              </p>
              <div className="w-7 h-7 sm:w-9 sm:h-9 bg-white bg-opacity-20 rounded-lg flex items-center justify-center flex-shrink-0 ml-2">
                <card.icon className="w-3.5 h-3.5 sm:w-5 sm:h-5" />
              </div>
            </div>
            <p className="text-xl sm:text-2xl font-black truncate">{card.value}</p>
          </div>
          <div className="absolute -bottom-3 -right-3 w-20 h-20 sm:w-24 sm:h-24 bg-white opacity-5 rounded-full" />
        </div>
      ))}
    </div>
  );
}
